import api from 'shared/api';
import { formatOrderBy } from 'shared/helpers';

const buildFilterQuery = (filters = {}) =>
  Object.entries(filters)
    .filter(
      ([, value]) => value !== null && value !== undefined && value !== '',
    )
    .map(([key, value]) => `&${key}=${encodeURIComponent(value)}`)
    .join('');

export const fetchLicenseUsers = ({
  limit = 20,
  offset = 0,
  query = '',
  queryType = '',
  orderBy = [],
  filters = {},
} = {}) => {
  const searchQuery =
    query && queryType ? `&${queryType}=${encodeURIComponent(query)}` : '';
  const filterQuery = buildFilterQuery(filters);
  const orderQuery = formatOrderBy(orderBy);
  const url = `/api/v1/users/?limit=${limit}&offset=${offset}${searchQuery}${filterQuery}${orderQuery}`;
  return api.get(url);
};

export const fetchLicenseUser = (userId) => {
  const url = `/api/v1/users/${userId}/`;
  return api.get(url);
};

export const patchLicenseUser = (userId, data) => {
  const url = `/api/v1/users/${userId}`;
  return api.patch(url, data);
};

export const fetchLicenseUserGroups = ({
  limit = 20,
  offset = 0,
  query = '',
  queryType = '',
  orderBy = [],
  filters = {},
} = {}) => {
  const searchQuery =
    query && queryType ? `&${queryType}=${encodeURIComponent(query)}` : '';
  const filterQuery = buildFilterQuery(filters);
  const orderQuery = formatOrderBy(orderBy);
  const url = `/api/v1/license-user-groups/?limit=${limit}&offset=${offset}${searchQuery}${filterQuery}${orderQuery}`;
  return api.get(url);
};

export const fetchLicenses = ({
  limit = 20,
  offset = 0,
  query = '',
  queryType = '',
  orderBy = [],
  filters = {},
} = {}) => {
  const searchQuery =
    query && queryType ? `&${queryType}=${encodeURIComponent(query)}` : '';
  const filterQuery = buildFilterQuery(filters);
  const orderQuery = formatOrderBy(orderBy);
  const url = `/api/v1/licenses/?limit=${limit}&offset=${offset}${searchQuery}${filterQuery}${orderQuery}`;
  return api.get(url);
};

export const fetchLicenseManagers = ({
  groupId,
  limit = 20,
  offset = 0,
  query = '',
  queryType = '',
  filters = {},
} = {}) => {
  const searchQuery =
    query && queryType ? `&${queryType}=${encodeURIComponent(query)}` : '';
  const filterQuery = buildFilterQuery(filters);
  const url = `/api/v1/license-user-groups/${groupId}/managers?limit=${limit}&offset=${offset}${searchQuery}${filterQuery}`;
  return api.get(url);
};

export const fetchLicenseUserGroupMembers = ({
  groupId,
  limit = 20,
  offset = 0,
  query = '',
  queryType = '',
  orderBy = [],
  filters = {},
} = {}) => {
  const searchQuery =
    query && queryType ? `&${queryType}=${encodeURIComponent(query)}` : '';
  const filterQuery = buildFilterQuery(filters);
  const orderQuery = formatOrderBy(orderBy);
  const url = `/api/v1/license-user-groups/${groupId}/members/?limit=${limit}&offset=${offset}${searchQuery}${filterQuery}${orderQuery}`;
  return api.get(url);
};

export const fetchLicenseUserGroup = (groupId) => {
  const url = `/api/v1/license-user-groups/${groupId}/`;
  return api.get(url);
};

export const patchLicenseUserGroup = (groupId, data) => {
  const url = `/api/v1/license-user-groups/${groupId}/`;
  return api.patch(url, data);
};
